<canvas #canvas class="petals-canvas" aria-hidden="true"></canvas>
